
import Vue from 'vue'

import { ArticleType } from '@/models'
import Loader from '~/components/Loader.vue'

export default Vue.extend({
  name: 'ArticleList',
  components: {
    Loader
  },
  props: {
    data: {
      type: Array as Vue.PropType<ArticleType[]>,
      default: () => []
    },
    isLoading: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    isYouTubeUrl(url?: string): boolean {
      if (!url) {
        return false
      }
      try {
        const u = new URL(url)
        const host = u.hostname.toLowerCase()
        return host.includes('youtube.com') || host.includes('youtu.be')
      } catch (e) {
        return /youtube\.com|youtu\.be/i.test(url)
      }
    }
  }
})
